import React from 'react';
import { Route, Switch } from 'react-router-dom';
import asyncComponent from '../../../util/asyncComponent';

const BuffetMaster = asyncComponent(() => import('./BuffetMaster'));
const MasterTicketType = asyncComponent(() => import('./MasterTicketType'));
const OpeningOfShifts = asyncComponent(() => import('./OpeningOfShifts'));
const PrepareBuffetTickets = asyncComponent(() => import('./PrepareBuffetTickets'));

const Entry = ({ match }) => (
  <Switch>
    <Route exact path={`${match.url}/BuffetMaster`} component={BuffetMaster} />
    <Route exact path={`${match.url}/MasterTicketType`} component={MasterTicketType} />
    <Route exact path={`${match.url}/OpeningOfShifts`} component={OpeningOfShifts} />
    <Route exact path={`${match.url}/PrepareBuffetTickets`} component={PrepareBuffetTickets} />
  </Switch>
);

export default Entry;
